/**
 * Product Form Components
 *
 */

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.formType = this.form.dataset.format;
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-container] select');
    const pdpContainer = this.closest('.product-details-wrapper');
 	const country = document.querySelector('#CountryListBtn').getAttribute('data-value') || 'US';
    
    if(this.formType == 'product-page' && (document.querySelectorAll('variant-selects').length == 0 && document.querySelectorAll('variant-radios').length == 0)){
    	window.globalVariables.product.currentVariant = JSON.parse(this.form.querySelector('[data-variantJSON]').textContent)[0];
    }
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    let currentVariant = window.globalVariables.product.currentVariant.id;
 
    if(country != 'US' && window.globalVariables.product.currentVariant.metafields != null){            
      const a = window.globalVariables.product.currentVariant.metafields[country];
      if(a != undefined) currentVariant = a;
    }
    
    const body = JSON.stringify({
          id: currentVariant,
          quantity: qtyInput.value,
     	  properties: {
            _default_us: window.globalVariables.product.id
          }
        });   
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartElement.getCartData('open_drawer');
        // qtyInput.value = 1;
      })
      .catch((e) => {        
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
        return false;
    }else if(action == 'decrease'){
        finalQty = currentQty - 1;
    }else{
        finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    this.setCurrentVariant();
   
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if(!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        if(event){
          if(event == 'load'){
           // templateProductJS.prototype.manageVariantSlider(this.currentVariant);
           this.manageVariantSlider(this.currentVariant); 
          }else if(event){
            let currentTarget = event.target;
            let pdpContainer = currentTarget.closest('[data-product-container]');
            let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
            let targetName = currentTarget.getAttribute('name') || '';
            targetName = targetName.toLowerCase();

            if(pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)){              
                // templateProductJS.prototype.manageVariantSlider(this.currentVariant);  
                this.manageVariantSlider(this.currentVariant);            
            }
          }
        }

        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  manageVariantSlider(variant){
    const productJSON = window.globalVariables.product;
    const productSliderType = selectors.productContainer.dataset.slider_type;
    
    
        const currentVariant = variant || window.globalVariables.product.currentVariant;
        const colorName = currentVariant.option1.toLowerCase();
        const colorMedia = [];
        console.log("gggg");
        mediaJSON.forEach(media => {
            let mediaAlt = media.alt;
            if(mediaAlt) mediaAlt = mediaAlt.toLowerCase();
            if(mediaAlt == colorName) colorMedia.push(media);
        });
        window.productMedia = colorMedia;

        if(window.globalVariables.templateSuffix == 'layout2'){
            const imagesParent = document.querySelector('[data-productImagesContainer]');
            if(!imagesParent || colorMedia.length <= 0) return;
            let slidesHTML = '';
            colorMedia.forEach(function(i,v){
                let imageAlt = i.alt.toLowerCase();
                if(imageAlt == colorName){
                    if(i.media_type == "external_video"){
                        slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                            <div class="custom-video-container">
                                <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                    <div class="cta-btn" data-aos="hero">
                                        <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                            <i class="icon-play text-body"></i>
                                        </button>
                                        <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                            <i class="icon-pause"></i>
                                        </button>
                                    </div>
                                    <div class="content-section">
                                        <div class="poster-image">
                                            <img class="img-fluid"
                                            src="${i.preview_image.src}"
                                            alt="${i.alt}"/>
                                        </div>
                                    </div>
                                    <div class="video-section" tabindex="0"></div>
                                </custom-video>
                            </div>
                        </div>`;
                    }else if(i.media_type == "video"){
                        slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                            <div class="custom-video-container">
                                <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                    <div class="cta-btn">
                                        <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                            <i class="icon-play text-body"></i>
                                        </button>
                                        <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                            <i class="icon-pause"></i>
                                        </button>
                                    </div>
                                    <div class="content-section">
                                        <div class="poster-image">
                                            <img class="img-fluid"
                                            src="${i.preview_image.src}"
                                            alt="${i.alt}"/>
                                        </div>
                                    </div>
                                    <div class="video-section" tabindex="0"></div>
                                </custom-video>
                            </div>
                        </div>`;
                    }else{
                        slidesHTML+= `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                        <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                            <img class="img-fluid"
                            src="${i.preview_image.src}"
                            alt="${i.alt}"/>
                        </div>`;
                    }
                }
            });
            imagesParent.innerHTML= slidesHTML;
        }else{
            const thumbParent = document.querySelector('[data-thumbSlider]');
            const sliderParent = document.querySelector('[data-main-slider]');

            if(!thumbParent || !sliderParent || colorMedia.length <= 0) return;

            let thumbnailsHTML = '';
            let slidesHTML = '';
            colorMedia.forEach(function(i,v){
                let imageAlt = i.alt.toLowerCase();
                if(imageAlt == colorName){
                    if(i.media_type == "external_video"){
                        thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                        <img class="img-fluid"
                            src="${i.preview_image.src}"
                            alt="${i.alt}"/>
                            <i class="icon-play position-absolute"></i>
                        </div>`;
                        slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                            <div class="custom-video-container">
                                <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                    <div class="cta-btn" data-aos="hero">
                                        <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                            <i class="icon-play text-body"></i>
                                        </button>
                                        <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                            <i class="icon-pause"></i>
                                        </button>
                                    </div>
                                    <div class="content-section">
                                        <div class="poster-image">
                                            <img class="img-fluid"
                                            src="${i.preview_image.src}"
                                            alt="${i.alt}"/>
                                        </div>
                                    </div>
                                    <div class="video-section" tabindex="0"></div>
                                </custom-video>
                            </div>
                        </div>`;
                    }else if(i.media_type == "video"){
                        thumbnailsHTML+= `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                        <img class="img-fluid"
                            src="${i.preview_image.src}"
                            alt="${i.alt}"/>
                            <i class="icon-play position-absolute"></i>
                        </div>`;
                        slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                            <div class="custom-video-container">
                                <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                    <div class="cta-btn">
                                        <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                            <i class="icon-play text-body"></i>
                                        </button>
                                        <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                            <i class="icon-pause"></i>
                                        </button>
                                    </div>
                                    <div class="content-section">
                                        <div class="poster-image">
                                            <img class="img-fluid"
                                            src="${i.preview_image.src}"
                                            alt="${i.alt}"/>
                                        </div>
                                    </div>
                                    <div class="video-section" tabindex="0"></div>
                                </custom-video>
                            </div>
                        </div>`;
                    }else{
                        thumbnailsHTML+= `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                            src="${i.preview_image.src}"
                            alt="${i.alt}"/>
                        </div>`;
                        slidesHTML+= `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                            <div data-productZoom class="product-zoom"><i class="icon-zoom icon-size-18"></i></div>
                            <img class="img-fluid"
                            src="${i.preview_image.src}"
                            alt="${i.alt}"/>
                        </div>`;
                    }
                }
            });

            let navDirection = thumbParent.dataset.direction || 'horizontal';
            let finalnavHTML = `
                <div class="swiper-slider product-thumbnails" role="tree" 
                        data-slider='{
                            "direction": "${navDirection}",
                            "loop": false,
                            "slidesPerView": "6",
                            "spaceBetween": 15,
                            "grabCursor": true,
                            "slideToClickedSlide": true
                        }' >
                    <div class="swiper-wrapper">${thumbnailsHTML}</div>
                </div>`;
            thumbParent.innerHTML= finalnavHTML;

            let finalHTML = `<slider-element class="swiper-container carousel">
                                <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails"
                                    data-slider='{
                                            "loop": false,
                                            "slidesPerView": "1",
                                            "spaceBetween": 15,
                                            "grabCursor": true,
                                            "navigation": {
                                                "nextEl": ".swiper-button-next",
                                                "prevEl": ".swiper-button-prev"
                                            },
                                            "pagination": {
                                                "el": ".swiper-pagination"
                                            }
                                        }' role="tree">
                                    <div class="swiper-wrapper" >${slidesHTML}</div>
                                    <div class="swiper-pagination"></div>
                                </div>
                            </slider-element>`;
            sliderParent.innerHTML= finalHTML;
        }
        
        selectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
        selectors.zoomBtns.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });
    
}

  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    
    if(priceElement){
      // let sPrice = price.split('.');
      priceElement.innerHTML = price;
    }
    if(comparePriceElement) {
      // let cPrice = compare_price.split('.');
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }    
    
    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');    
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;      
      const lable = option.querySelector('.selected-option');      
      if(!lable || !lableID) return;
      lable.innerHTML = `/ ${currentVariant[lableID]}`;
    });

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      if(!currentVariant.featured_media) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }
    
  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();

      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;
      
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          if(swatchStyle != false) swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);